import config from '../config';

export default (freeslots: any) => {
    let apmTypeTopics = {};

    for (let slot in freeslots) {
        const keyType = config.appointman.apmTypeMapping[slot];
        apmTypeTopics[keyType] = [];
        if ('object' === typeof freeslots[slot].topics) {
            apmTypeTopics[keyType] = freeslots[slot].topics;
        }

    }

    return apmTypeTopics;
};



// WEBPACK FOOTER //
// ./app/bundles/appointman/app/ts/utils/extractApmTypeTopics.ts